export default __webpack_public_path__ + "static/media/header-rocket-logo.969831df.svg";